module.exports = __webpack_public_path__ + "static/img/zhongyao.efd62f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/zhongyao.png
// module id = P4xS
// module chunks = 1